import { BRAND, CATEGORIES, CONTACT_EMAIL, NAV_LINKS, SITE_SLOGAN } from "@/mocks/melon";

function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="relative flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-primary-400 to-primary-600 text-background-50">
                <span className="text-lg font-black leading-none">{BRAND.charAt(0)}</span>
                <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full bg-accent-400 ring-2 ring-primary-950 animate-pulse" />
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-background-50">
                {BRAND}
                <span className="ml-1 text-primary-200">·实时瓜讯</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-100/80">
              {SITE_SLOGAN}。我们实时跟进全网热搜瓜点，主打信源清晰、吃瓜有度，让追更更轻松、判断更清醒。
            </p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="mt-4 inline-flex items-center gap-2 text-sm text-accent-200 hover:text-accent-100"
            >
              <i className="ri-mail-line" /> {CONTACT_EMAIL}
            </a>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-sm font-bold uppercase tracking-wider text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.key}>
                  <a href={l.href} className="text-sm text-primary-100/75 transition-colors hover:text-background-50">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-sm font-bold uppercase tracking-wider text-background-50">内容分类</h4>
            <ul className="mt-4 space-y-2.5">
              {CATEGORIES.filter((c) => c !== "全部").map((c) => (
                <li key={c}>
                  <a href="#latest" className="text-sm text-primary-100/75 transition-colors hover:text-background-50">
                    {c}热点
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-sm font-bold uppercase tracking-wider text-background-50">订阅瓜场快讯</h4>
            <p className="mt-4 text-sm text-primary-100/75">不错过任何正在发酵的瓜，把当天的热点打包给你。</p>
            <a
              href="#subscribe"
              className="mt-4 inline-flex h-10 items-center gap-1.5 rounded-md bg-accent-500 px-5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-send-line" /> 立即订阅
            </a>
            <div className="mt-5 flex items-center gap-2 text-xs text-primary-100/60">
              <i className="ri-time-line" /> 榜单秒级更新 · 信源优先 · 尊重当事人
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-primary-800 pt-6 text-xs text-primary-100/60 sm:flex-row">
          <p>© 2026 {BRAND} · 全网热搜实时资讯整理与分享</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-flower-line text-accent-300" />
            理性吃瓜，快乐追更
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;